const MAX_DISPLAY_SEC = 10 * 60
const KST_OFFSET_HOURS = 9

// 서버는 timezone 표기 없는 "YYYY-MM-DD HH:mm:ss" 형식으로 KST 시각을 내려줌.
// JS new Date() 동작이 환경별로 달라(iOS WebKit은 Invalid Date) 명시 파싱.
const parseServerDateTime = (input: string): number => {
  if (/[Zz]$|[+-]\d{2}:?\d{2}$/.test(input)) {
    return new Date(input).getTime()
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?$/.exec(input)
  if (!match) return NaN
  const [, year, month, day, hour, minute, second] = match
  return Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour) - KST_OFFSET_HOURS, Number(minute), Number(second))
}

export const formatTimeAgo = (createdAt: string): string | null => {
  const created = parseServerDateTime(createdAt)
  if (Number.isNaN(created)) return null

  const diffSec = Math.max(0, Math.floor((Date.now() - created) / 1000))
  if (diffSec >= MAX_DISPLAY_SEC) return null

  if (diffSec < 60) return '방금 전'
  return `${Math.floor(diffSec / 60)}분 전`
}
